import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge must know the design-system type scale (globals.css `--text-*`), otherwise it
 * takes `text-small` for a colour (and `shadow-raised` for a shadow colour) and drops e.g. `text-primary-foreground` next to it.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        'display',
        'h1',
        'h2',
        'h3',
        'section',
        'body',
        'body-strong',
        'small',
        'label',
        'caption',
        'overline',
        'stat',
        'stat-sm', // T-093
        'item', // T-093
      ],
      shadow: ['card', 'popover', 'dialog', 'raised'],
      radius: ['xl'],
    },
  },
});

/** Merges Tailwind class names, letting later utilities override earlier ones (shadcn/ui). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
